import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Image from 'src/components/ui/Image/Image';
import { useParams } from 'react-router-dom';
import styles from './ProductCard.module.scss';
import { useProductImageQuery } from '../../../services/customerTracking';
import Icon from '../Icon/Icon';

export interface ProductCardProps {
  card: {
    id: number;
    title: string;
    copy?: string;
  };
}

const ProductCard: React.FC<ProductCardProps> = ({ card: { id, title, copy } }) => {
  const { trackingKey } = useParams();
  const keyString = String(trackingKey);

  const { data: image } = useProductImageQuery(keyString, id);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!(image instanceof Blob)) return;

    const url = URL.createObjectURL(image);
    setImageUrl(url);
  }, [image]);

  return (
    <div className={classNames(styles.root)}>
      <div className={classNames(styles.image)}>
        <Image
          imageUrl={imageUrl || ''}
          alt=""
          fallbackComponent={
            <div className="flex justify-center items-center w-full h-full md:w-[230px] md:h-[157px]">
              <Icon className="text-color-grey-200 w-8 h-8 md:w-[40px] md:h-[40px]" name="package" />
            </div>
          }
        />
      </div>
      <div className="flex justify-between items-center gap-x-8 px-12 md:py-24">
        <div className="flex flex-col md:gap-y-6">
          <h3 className="typo-text-14--bold text-full">{title}</h3>
          {copy && <p className="typo-text-12 text-faded">{copy}</p>}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
